import {useUserListQuery} from '../../graphql';
import {ErrorView} from '../GraphQL/ErrorView';
import {UserListContainer} from './container';
import React from 'react';

export const UserListGraphQL = () => {
  const [userListResult] = useUserListQuery({requestPolicy: 'network-only'});
  const {data, fetching, error} = userListResult;
  const users = data?.users ?? [];

  return (
    <ErrorView fetching={fetching} errors={[error]}>
      <UserListContainer users={users}/>
    </ErrorView>
  );
};
